import { Navigate } from 'react-router-dom';
import { hasRole } from '../../utils/helpers';
import { hasDomain, isBootstrapAdmin } from '../../utils/authStorage';

/**
 * Client-side route guard for admin pages. UX only — Django rejects the same
 * calls with 403 regardless of what the UI renders.
 */
export function RequireAccess({ roles, bootstrapOnly = false, children }) {
  const allowed = bootstrapOnly
    ? isBootstrapAdmin()
    : isBootstrapAdmin() || (roles ? hasRole(roles) : true);

  if (allowed) return children;
  if (hasDomain('construction')) return <Navigate to="/construction/projects" replace />;
  if (hasDomain('surveillance')) return <Navigate to="/dashboard" replace />;
  return <Navigate to="/login" replace />;
}
